// libs
import React from 'react'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants'

// components
import SelectField from 'src/components/forms/select-field/select-field'
import LoadingSpinnerWrapper from 'src/components/loading_spinner/loading_spinner_wrapper'
import { ProfilesList } from 'src/components/profiles_list/profiles_list'
import ProfileListWrapper from 'src/containers/smart_components/list_wrapper/profile_list_wrapper'

// helpers
import { textResources } from 'src/lang/de'

import {
  ActorProfilePreviewFragmentFragment,
  ProfileSortingKeys
} from '@lopo-tech/lopo-api'
import 'src/containers/smart_components/profiles_directory/profiles_directory.scss'
import { IOrderByOption } from '../../../pages/profiles_directory_category'

const cls = CLASS_PREFIX + 'profiles-directory'
const labels = textResources.profileList

interface IProps {
  currentPage: number;
  getNextPage: () => void;
  loading: boolean;
  profilesListData: ActorProfilePreviewFragmentFragment[]
  showNewPostButton?: boolean;
  onVisibleChange?: (id: string, inView: boolean) => void,
  orderBy: string,
  onChange: (value: ProfileSortingKeys) => void,
  orderByOptions: IOrderByOption[],
}

const ProfilesDirectoryCategory: React.FC<IProps> = ({
  currentPage,
  getNextPage,
  loading,
  profilesListData,
  onVisibleChange,
  orderBy,
  onChange,
  orderByOptions
}) => {
  return (
    <LoadingSpinnerWrapper isLoading={loading}>
      <ProfileListWrapper
        currentPage={currentPage}
        getNextPage={getNextPage}
        initialLoad={false}
      >
        <div className={cls}>
          {!profilesListData.length
            ? !loading && <p className={cls + '__empty'}>
              {textResources.shared.noLocalResultFound}
            </p>
            : <>
              <SelectField
                label={labels.orderBy}
                options={orderByOptions}
                value={orderBy}
                onChange={onChange}
              />
              <ProfilesList profiles={profilesListData} onVisibleChange={onVisibleChange} />
            </>}
        </div>
      </ProfileListWrapper>
    </LoadingSpinnerWrapper>
  )
}

ProfilesDirectoryCategory.displayName = 'ProfilesDirectoryCategory'

export default ProfilesDirectoryCategory
